/*global math, Algebrite, Element_Algebra_Polynom*/ //ESLINT

//KAS Library works only with require => Utils-Algebra.js (not .mjs)
//KAS IMPORTS
//NODE MODULES TO INSTALL TO MAKE KAS WORK :
// underscore, qunit , qunit-assert-close, jison (see test.html in KAS github project )
import _ from "underscore";
window._ = _;
import KAS from "../../../lib/kas/kas.js";
window.KAS = KAS;
//require("../../../lib/kas/src/parser-generator.js");
require("../../../lib/kas/src/parser.js");
require("../../../lib/kas/src/unitparser.js");
require("../../../lib/kas/src/nodes.js");
require("../../../lib/kas/src/compare.js");

/* UNIT TESTS KAS Library */

var expr1 = KAS.parse("(1-x)(-1-6x)").expr;
var expr2 = KAS.parse("(6x+1)(x-1)").expr;
console.log("KAS", KAS.compare(expr1, expr2).equal);

//var expr = KAS.parse("3x \\frac{42}{42} sin^2y").expr;
//console.log("KAS", expr.print());

export const symbolicEqual = symbolicEqualWithKAS; //change by symbolicEqualWithAlgebrite if more powerful at the end
/**
 * Symbolic equal with Algebrite (test if ((Exp A) - (Exp B)) == 0 )
 * @param {*} exp1
 * @param {*} exp2
 * @returns
 */
export function symbolicEqualWithAlgebrite(exp1, exp2) {
  var returnBool = false;
  try {
    var expr1 = "(" + flatExpression(exp1) + ")";
    var expr2 = "(" + flatExpression(exp2) + ")";
    console.log("symbolicEqual", exp1, exp2, expr1, expr2);
    returnBool = Algebrite.run(expr1 + "-" + expr2) == "0";
  } catch (e) {
    console.log("symbolicEqual error:", e);
  }
  return returnBool;
}

/**
 * Compare two expressions with Khan/KAS Library
 * If needed possibly migrate with Algebrite Alebrite.run(exp1 + "-" + exp2) == 0
 * we manage symbolicEqual manualy here
 * @param {*} exp1
 * @param {*} exp2
 * @returns
 */

export function symbolicEqualWithKAS(exp1, exp2) {
  var returnBool = false;
  try {
    var expr1 = new KAS.parse(flatExpression(exp1)).expr;
    var expr2 = new KAS.parse(flatExpression(exp2)).expr;
    console.log(
      "symbolicEqual",
      exp1.toString(),
      exp2.toString(),
      expr1,
      expr2
    );
    returnBool = KAS.compare(expr1, expr2).equal;
  } catch (e) {
    console.log("symbolicEqual error:", e);
  }
  return returnBool;
}

/**
 * Mimic of derivative from mathjs // => Algebrite
 * @param {*} expression
 * @param {*} variable
 */
export function derivative(expression, variable) {
  if (expression instanceof Element_Algebra_Polynom) {
    let returnedExp = parseExpression(expression.derivative().toString());
    console.log("derivative is Element_Algebra_Polynom", returnedExp);
    return returnedExp;
  } else {
    return window.math.derivative(flatExpression(expression), variable);
  } //console.log("derivative", flatExpression);
  //return math.parse(Algebrite.derivative(flatExpression, variable).toString());
}

/**
 * Integral from => Algebrite
 * @param {*} expression
 * @param {*} variable
 */
export function primitive(expression, variable) {
  if (expression instanceof Element_Algebra_Polynom) {
    let returnedExp = parseExpression(expression.primitive().toString());
    console.log("primitive is Element_Algebra_Polynom", returnedExp);
    return returnedExp;
  } else {
    return parseExpression(
      Algebrite.integral(flatExpression(expression), variable).toString()
    );
  }
}

/**
 * Integral from => Algebrite
 * @param {*} expression
 * @param {*} variable
 */
export function integral(expression, variable, inf, sup) {
  return parseExpression(
    Algebrite.defint(flatExpression(expression), variable, inf, sup).toString()
  );
}

/**
 * Mimic of evaluate from mathjs
 * @param {*} expression
 * @param {*} json
 */
export function evaluate(flatExpression, json) {
  var node = parseExpression(flatExpression); //convert into Str in any case
  var code = node.compile();
  if (node && !node.value === "undefined") {
    //si la valeur de l'objet mathjs est undefined (exemple réponse vide de l'élève)
    return math.round(code.evaluate(json), 14); //round to 14 digits to avoid precision js bug
  } else {
    return code.evaluate(json);
  }
}

/**
 * FLat an math expression or an simple string and return a string well formed understandable by mathjs and Algebrite
 * @param  {String} math expression or string
 * @returns {String}
 */
export function parseExpression(expression) {
  var parsedExpression = math.parse(expression);
  return roundConstantInExpression(parsedExpression);
}
/**
 * roundConstantInExpression add the capacity to math.parse to round to 14 decimals all constant in expression
 * It was created specificly because sometimes Algebrite add round errors when manipulate expressions.
 * @param {*} expression
 * @returns
 */
function roundConstantInExpression(expression) {
  var roundedExpression = expression;
  roundedExpression = roundedExpression.transform(function (
    node,
    path,
    parent
  ) {
    if (node && node.isConstantNode && typeof node.value !== "undefined") {
      console.log("roundConstantInExpression isConstantNode");
      return new math.ConstantNode(math.round(node.value, 14));
    } else {
      return node;
    }
  });
  return roundedExpression;
}

/**
 * FLat an math expression or an simple string and return a string well formed understandable by mathjs and Algebrite
 * @param  {String} math expression or string
 * @returns {String}
 */
export function flatExpression(expression) {
  console.log("flatExpression:", expression, expression.toString());
  try {
    if (expression) {
      return expression.toString({
        notation: "fixed",
        implicit: "show",
        parenthesis: "all",
      });
    } else {
      return "";
    }
  } catch (e) {
    console.log("Impossible to flat math expression:", e);
    return "";
  }
}
/**
 * Test wether a string can be parsable via mathjs (it's an math expression or not)
 * It also works for equality "f(x)=2*x"
 * @param {*} str
 * @returns
 */
export function isMathParsableString(str) {
  try {
    parseExpression(str);
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Mimic of degree from mathjs
 * @param {*} flatExpression
 * @param {*} variable
 */
export function degree(flatExpression, variable) {
  //console.log("degree", Algebrite.deg(flatExpression, variable).toString());

  return math.number(Algebrite.deg(flatExpression, variable).toString());
}

/**
 * Coefficients of expression / polynom from Algebrite
 * @param {*} flatExpression
 * @param {*} variable
 */
export function coefficients(flatExpression, variable) {
  let returnedList = [];
  // console.log("coefficients", degree(flatExpression, variable));
  let degreeOfPolynom = degree(flatExpression, variable);
  for (let deg = 0; deg <= degreeOfPolynom; deg++) {
    //Algebrite.coeff returns a JSObject use call toString proto to get the number value in String
    returnedList.push(
      math.number(Algebrite.coeff(flatExpression, variable, deg).toString())
    );
  }
  //return reverse to fit international convention
  return returnedList.reverse();
}

//////////////KHAS OR MATHJS METHODS NOT USED ANYMORE

/**
 * Compare two expressions with Khan/KAS Library
 * we manage symbolicEqual manualy here
 * @param {*} exp1
 * @param {*} exp2
 * @returns
 */
/*
export function simplify_KAS(expression) {
  var returnExpr = "";
  try {
    var expr1 = new KAS.parse(
      expression.toString({
        notation: "fixed",
        implicit: "show",
        parenthesis: "all",
      })
    ).expr;
    returnExpr = expr1.collect().print();
  } catch (e) {
    console.log("simplify error:", e);
  }
  return returnExpr;
}*/

/**
 * NO MORE USED Compare two expressions with MathJS 10.0.0.
 * Info : with MathJS > 10.0.3 (to check) manages it internaly. But, because we had to keep mathjs to 10.0.0 with older fractions.js version (to handle reducing manually)
 * we manage symbolicEqual manualy here
 * @param {*} exp1
 * @param {*} exp2
 * @returns
 */
/*
export function symbolicEqual(exp1, exp2) {
  var expr1 = new math.parse(exp1.toString());
  var expr2 = new math.parse(exp2.toString());

  const diff = new math.OperatorNode("-", "subtract", [expr1, expr2]);
  const simplified = math.simplify(diff, {});

  return simplified;
}*/
